export default "__VITE_ASSET__BznjXirE__"